import UIListener from '@/UIListener/UIListener';
import ComponentManager from '@/Management/ComponentManager';
import DetailViewContext from '@/ViewModels/Contexts/DetailViewContext';
import ControlFactory from '@/Factories/ControlFactory';

export default class SmtpConnectionTypeUIListener extends UIListener {

    /**
     * @override
     */
    public onDetailViewReady(context: DetailViewContext) {
        super.onDetailViewReady(context);
        
        this.updateVisibility(context);
    }

    /**
     * @override
     */
    public onPropertyValueUpdated(context: DetailViewContext, property: any) {
        super.onPropertyValueUpdated(context, property);
        
        if (property === 'ConnectionType.Value')
            this.updateVisibility(context);
    }

    private updateVisibility(context: DetailViewContext): void {
        const isSmtp = this.isSmtp(context);
        this.updateFactoryVisibility('Host', isSmtp, context);
        this.updateFactoryVisibility('Port', isSmtp, context);
        this.updateFactoryVisibility('SSL', isSmtp, context);
        this.updateFactoryVisibility('Password', isSmtp, context);
        this.updateFactoryVisibility('Username', isSmtp, context);

        this.updateFactoryVisibility('ClientId', !isSmtp, context);
        this.updateFactoryVisibility('TenantId', !isSmtp, context);
        this.updateFactoryVisibility('DecryptedClientSecret', !isSmtp, context);
    }
    
    private updateFactoryVisibility(name: string, isVisible: boolean, context: DetailViewContext): void {
        const factory = context.getUIFactory<ControlFactory>(name);
        if(factory) {
            factory.isVisible(isVisible);
        }
    }
    
    private isSmtp(context: DetailViewContext): boolean {
        const type = context.genericObject.getValue('ConnectionType.Value');
      
        if (type === 'SMTP')
            return true;
        
        if(type === 'Microsoft_Graph_API')
            return false;
        
        console.error('Unsupported type for ConnectionType: ' + type);
        return true;
    }
}

ComponentManager.setUIListener('SmtpConnectionTypeUIListener', SmtpConnectionTypeUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');
ComponentManager.setUIListener('RADPresentation.DefaultViewExtensions.UIListener.SmtpConnectionTypeUIListener', SmtpConnectionTypeUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');